export default __webpack_public_path__ + "static/media/icon-assets-default.feeb79dd.svg";